import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Alert, Copy } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import { compiler } from 'markdown-to-jsx';
import { useSharedApps, useAppName } from '../../../utils/sitecoreContext';
import { CONTACT_DEALER_URL, BOOK_AN_APPOINTMENT_URL } from '../../../utils/constants';
import { selectDealer } from '../../../core/reducers/dealer';
import { useAppSelector } from '../../../core/utils';
import useGetLinkSearchParams, { FEATURE_ORIGIN_BAP } from '../hooks/useGetLinkSearchParams';
import getLeadFormParamsByAppName from '../utils/getLeadFormParamsByAppName';
import themeStyles from './styles/InventoryStatusWarning.styles';
import gtmLowInventoryWarning from '../utils/gtmInventoryWarning';
import useGetInventoryUrl from '../hooks/useGetInventoryUrl';
const Link = themeStyles.apply('a', 'Link');
const InventoryStatusWarning = ({ message, dealerName, componentType, trim, availabilityFlag, gtmBodyStyle, }) => {
    const { t } = useTranslation();
    const appName = useAppName();
    const contactDealerBaseUrl = useSharedApps(CONTACT_DEALER_URL);
    const bookAppointmentBaseUrl = useSharedApps(BOOK_AN_APPOINTMENT_URL);
    const { dealerCode } = useAppSelector(selectDealer);
    const searchParams = useGetLinkSearchParams({
        dealerCode,
        generatePayload: getLeadFormParamsByAppName(appName, FEATURE_ORIGIN_BAP),
    });
    const viewInventoryLink = useGetInventoryUrl();
    // Generated link based on the availability of dealerCode
    const contactDealerLink = dealerCode
        ? `${contactDealerBaseUrl}?${searchParams}`
        : `${bookAppointmentBaseUrl}?${searchParams}`;
    if (!message)
        return null;
    const gtmProps = {
        dealerName,
        componentType,
        trim,
        availabilityFlag,
        bodyStyle: gtmBodyStyle,
        linkText: '',
        ctaPlacement: '',
    };
    const contactLinkHandler = () => {
        gtmLowInventoryWarning({
            ...gtmProps,
            linkUrl: contactDealerLink,
            isInventory: false,
        });
    };
    const inventoryLinkHandler = () => {
        gtmLowInventoryWarning({
            ...gtmProps,
            linkUrl: viewInventoryLink,
            isInventory: true,
        });
    };
    const warningMessage = `${t('Pages.Bap.limitedInventoryText', {
        modelList: message,
        contactDealerLink: `<ContactLink href="${contactDealerLink}" target="_blank" >${t('Pages.Bap.contactDealerLabel')}</ContactLink>`,
        viewInventoryLink: `<InventoryLink href="${viewInventoryLink}" target="_blank" >${t('Pages.Bap.viewInventoryLabel')}</InventoryLink>`,
    })}`;
    return (_jsx(Alert, { variant: "warning", iconSize: "large", mb: "l", dataTestId: "cy-inventory-status-warning-message", children: _jsx(Copy, { size: "extraSmall", fontFamily: "bold", children: compiler(warningMessage, {
                overrides: {
                    ContactLink: {
                        component: ({ children, ...props }) => (_jsx(Link, { "data-testid": "cy-contact-link", ...props, onClick: contactLinkHandler, children: children })),
                    },
                    InventoryLink: {
                        component: ({ children, ...props }) => (_jsx(Link, { "data-testid": "cy-inventory-link", ...props, onClick: inventoryLinkHandler, children: children })),
                    },
                },
            }) }) }));
};
export default InventoryStatusWarning;
